import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { timestatementTab } from './constant';
import { types as sdkTypes } from '../../util/sdkLoader';
import { denormalisedResponseEntities } from '../../util/data';
import { apiBaseUrl } from '../../util/api';
import axios from 'axios';
import moment from 'moment';
const { UUID } = sdkTypes;
const TIMESTATEMENT_FETCH_REQUEST = 'app/WorkerTimestatement/TIMESTATEMENT_FETCH_REQUEST';
const TIMESTATEMENT_FETCH_SUCCESS = 'app/WorkerTimestatement/TIMESTATEMENT_FETCH_SUCCESS';
const TIMESTATEMENT_FETCH_ERROR = 'app/WorkerTimestatement/TIMESTATEMENT_FETCH_ERROR';

const initialState = {
  timestatementFetchInProgress: false,
  timestatementFetchError: null,
  timestatements: [],
};

export default function workerTimestatementReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TIMESTATEMENT_FETCH_REQUEST:
      return {
        ...state,
        timestatementFetchInProgress: true,
        timestatementFetchError: null,
        timestatements: [],
      };
    case TIMESTATEMENT_FETCH_SUCCESS:
      return {
        ...state,
        timestatementFetchInProgress: false,
        timestatements: payload,
      };
    case TIMESTATEMENT_FETCH_ERROR:
      return {
        ...state,
        timestatementFetchError: payload,
        timestatementFetchInProgress: false,
      };
    default:
      return state;
  }
}

//============================Action creator============================//
const timestatementFetchRequest = () => ({ type: TIMESTATEMENT_FETCH_REQUEST });
const timestatementFetchError = payload => ({ type: TIMESTATEMENT_FETCH_ERROR, payload });
const timestatementFetchSuccess = payload => ({ type: TIMESTATEMENT_FETCH_SUCCESS, payload });

//============== Thunk=================================================//

export const fetchTimestatement = queryParams => async (dispatch, getState, sdk) => {
  const { tab = timestatementTab.recent, listingId } = queryParams;
  dispatch(timestatementFetchRequest());

  async function queryTimestatement(query) {
    let page = 1,
      totalPages = 1;
    const timestatements = [];
    query.perPage = 100;
    const url = `${apiBaseUrl()}/api/timeStatement/get`;
    for (; page <= totalPages; page++) {
      query.page = page;
      const resp = await axios.get(url, { params: query });
      const { data, meta } = resp.data;
      let listingIds = Array.from(new Set(data.map(d => d.listingId)));
      listingIds = data.map(d => sdk.listings.show({ id: new UUID(d.listingId) }));
      const listingsResp = await Promise.allSettled(listingIds);
      const listings = listingsResp
        .filter(resp => resp.status === 'fulfilled')
        .map(resp => denormalisedResponseEntities(resp.value)[0])
        .reduce((acc, listing) => {
          acc[listing.id.uuid] = listing;
          return acc;
        }, {});
      data.forEach(d => {
        d.listing = listings[d.listingId];
        d.gigId = d.listing?.attributes?.publicData?.gigId;
      });

      timestatements.push(...data);
      totalPages = meta.totalPages;
      query.lastPageId = data[data.length - 1]?._id;
    }
    return timestatements;
  }

  return dispatch(fetchCurrentUser())
    .then(() => {
      const { currentUser } = getState().user;
      const workerId = currentUser.id.uuid;
      const userOffset = moment().utcOffset();
      const date = moment()
        .add(userOffset, 'm')
        .toISOString();
      const isDisputeMaybe = tab === timestatementTab.recent ? { isDispute: true } : {};
      const query = { workerId, tab, date, listingId, ...isDisputeMaybe };
      return queryTimestatement(query);
    })
    .then(data => {
      dispatch(timestatementFetchSuccess(data));
      return data;
    })
    .catch(err => {
      dispatch(timestatementFetchError(storableError(err)));
      return err;
    });
};

export const loadData = (params, search) => dispatch => {
  const queryParams = parse(search);
  return dispatch(fetchTimestatement(queryParams));
};
